import classNames from 'classnames';
import Progress from '../Progress/Progress';
import Info from '../Info/Info';
import Grade from '../Grade/Grade';
import Image from '../Image/Image';
import Timer from '../Timer/Timer';
import getAchievementProgress from '../../utils/getAchievementProgress';

export default function Achievement({ className, type, onClick }) {
  const progressData = getAchievementProgress(arguments[0]);
  const fullProps = { ...arguments[0], progressData };

  return (
    <div className={classNames('achievement', className, { [`achievement_${type}`]: type })} onClick={onClick}>
      <Image {...fullProps} />
      <Grade {...fullProps} />
      <Info {...fullProps} />
      <Progress {...fullProps} />
      <Timer {...fullProps} />
    </div>
  );
}
